export default {
  thomasGraf: {
    header: 'Thomas Graf',
    bio: `Thomas Graf is a Co-Founder of Cilium and the CTO & Co-Founder of <a href="https://isovalent.com/?utm_source=website-cilium&utm_medium=referral&utm_campaign=cilium-enterprise">Isovalent</a>, the company behind Cilium. Before that, Thomas spent 15 years as
    a kernel developer working on the <a href="https://kernel.org">Linux kernel</a> in networking, security and eventually eBPF.`,
  },
  lizRice: {
    header: `<a href="https://twitter.com/lizrice">Liz Rice</a>`,
    bio: `Liz is Chief Open Source Officer at <a href="https://isovalent.com/?utm_source=website-cilium&utm_medium=referral&utm_campaign=cilium-enterprise" target="_blank" rel="noopener noreferrer">Isovalent</a>, the company behind Cilium. She is also chair of the CNCF's Technical Oversight Committee, and the author of Container Security published by O'Reilly.`,
  },
  luanGuimaraes: {
    header: `Luan Guimarães`,
    bio: `Luan is a Brazilian rock climber, amateur musician, and
   programmer and am enthusiastic about free software communities and other
   open knowledge initiatives. He has been working as a Site Reliability
   Engineer at Wildlife Studios, using and building infrastructure tools on
   top of Kubernetes in order to support millions of users around the world.`,
  },
  joshVanLeeuwen: {
    header: `Josh Van Leeuwen`,
    bio: `Josh interned at Jetstack during the summer of 2017 before continuing to
    work part time during his final year of study at the University of Bristol.
    During this year, Josh developed a Kubernetes custom controller that
    automates the delegation of RBAC permissions based on time and event
    triggers. This work was later awarded the best Software Development Tool
    Final Year Project. Josh now works full time at Jetstack where if he’s not
    writing more Go, he’s making good food.`,
  },
  howardHao: {
    header: `Howard Hao`,
    bio: ` Howard Hao has been working as a Site Reliability Engineer for five years at
    Ect888.com since graduating from Shanghai Jiao Tong University. His team
    consists of 7 members and has been focusing on the construction of
    container orchestration platform like Kubernetes for one and a half years.`,
  },
  sergeyGeneralov: {
    header: `Sergey Generalov`,
    bio: `Sergey is a member of the technical staff at Isovalent
    and focuses on helping Cilium users solve challenges related
    to network policies, monitoring, and connectivity troubleshooting
    by building tools like Network Policy Editor, Hubble UI and more.`,
  },
  liWenquan: {
    header: `Li Wenquan`,
    bio: `Hello everyone, I am Li Wenquan from China. You can call me David. I
    started my Docker journey from 2014 and now work as a project manager of
    enterprise container platform, which is built on Kubernetes and Mesos. I
    got to know Cilium project from Kubecon, it is so interesting and
    promising. I've learned a lot from it, such as BPF, XDP and how to replace
    kube-proxy in a elegant way and I'd love to contribute to it.`,
  },
  alexanderAlemayhu: {
    header: `Alexander Alemayhu`,
    bio: `Alexander Alemayhu is a software engineer at Isovalent,
    the company behind Cilium. He has been working on eBPF and Linux
     kernel technologies for several years, focusing on networking and observability solutions.`,
  },
  DanielBorkmann: {
    header: `Daniel Borkmann`,
    bio: `Daniel Borkmann is a Distinguished Software Engineer, Isovalent at Cisco`,
  },
  ThomasGraf: {
    header: `Thomas Graf`,
    bio: `Thomas Graf is the CTO & Co-Founder Isovalent and also the Vice President Security Cisco`,
  },
  JedSalazar: {
    header: `Jed Salazar`,
    bio: `Jed Salazar is a Senior Solutions Architect, Isovalent`,
  },
  JedSalazarandJoeStringer: {
    header: `Jed Salazar and Joe Stringer`,
    bio: `Jed Salazar is a Senior Solutions Architect at Isovalent
    and Joe Stringer is a Principal Engineer, Isovalent at Cisco`,
  },
  JosephIrving: {
    header: `Joseph Irving`,
    bio: `Joseph Irving is a Platform Engineer Lead at RVU (Uswitch)`,
  },
  BillMulligan: {
    header: `Bill Mulligan`,
    bio: `Bill Mulligan is a Cilium and eBPF Community Pollinator,
    Isovalent at Cisco and a Governing Board Member of the eBPF Foundation.`,
  },
  OndrejBlazek: {
    header: `Ondrej Blazek`,
    bio: `Ondrej Blazek is an Infrastructure Engineer at Seznam.cz`,
  },
  LeonardCohnenandMoritzEckert: {
    header: `Leonard Cohnen and Moritz Eckert`,
    bio: `Leonard Cohnen and Moritz Eckert are team members at Edgeless Systems`,
  },
  PolArroyo: {
    header: `Pol Arroyo`,
    bio: `Pol Arroyo is a DevOps Engineer at Hetzner Cloud.`,
  },
  JedSalazarandMartynasPumputis: {
    header: `Jed Salazar and Martynas Pumputis`,
    bio: `Jed Salazar is a Senior Solutions Architect, Isovalent and Martynas Pumputis is a Principal Software Engineer, Isovalent at Cisco`,
  },
  ShedrackAkintayo: {
    header: `Shedrack Akintayo`,
    bio: `Shedrack Akintayo is a Community Manager at
    Isovalent helping build the eBPF and Cilium open source communities`,
  },
  AmirKheirkhahan: {
    header: `Amir Kheirkhahan`,
    bio: `Amir Kheirkhahan is a DevOps Specialist at DB Schenker handling design, development,
     deployment and maintenance of wide range of devops toolchain on top of Kubernetes clusters`,
  },
  PaulArah: {
    header: `Paul Arah`,
    bio: `Paul Arah is a Community Builder focused on Security at Isovalent (Cisco)`,
  },
  HimalKumar: {
    header: `Himal Kumar, Bhaskar Dutta, Arman Pashamokhtari`,
    bio: `Himal Kumar, Bhaskar Dutta, Arman Pashamokhtari are all part of the
     CanopusAI team Real Time Network Observability, powered by eBPF and Agentic AI`,
  },
  DoniaChaiehloudj: {
    header: `Donia Chaiehloudj`,
    bio: `Donia Chaiehloudj is a Senior Software Engineer and Community Oriented at Isovalent.
    She has been working on Cilium and eBPF technologies, focusing on networking and security solutions.`,
  },
  KatieMeinders: {
    header: `Katie Meinders`,
    bio: `Katie Meinders is a Community Builder at Isovalent where
    she helps grow the Cilium and eBPF communities through storytelling,
    social media, showcasing user success, and building connections across the open source ecosystem.`,
  },
  PeaceSandy: {
    header: `Peace Sandy`,
    bio: `Peace Sandy is an LFX mentee who contributed to improving Cilium SEO, AEO, and
    AIO during her mentorship period.`,
  },
  NehaAggarwal: {
    header: `Neha Aggarwal`,
    bio: `Neha Aggarwal is a Principal Engineer at Microsoft.`,
  },
  CharityMbisi: {
    header: `Charity Mbisi`,
    bio: `Charity Mbisi is an LFX mentee who contributed to improving Cilium's SEO, AEO, and AIO during his mentorship period.
    Professionally, Charity Mbisi is a Software Engineer consulting in the Fin-tech and banking industry, specializing in building cloud native computing solutions and optimized service delivery.`,
  },
  andreMartinsAndFerozSalam: {
    header: `André Martins and Feroz Salam`,
    bio: `André Martins is a Cilium maintainer and Software Engineer, Isovalent at Cisco.
    Feroz Salam is a member of the Cilium Security Team and a Security Engineer, Isovalent at Cisco.`,
  },
  ChristianHernandez: {
    header: `Christian Hernandez`,
    bio: `Christian is a well rounded technologist with experience in infrastructure engineering, systems administration, enterprise architecture, tech support, advocacy, and product management. Passionate about OpenSource and containerizing the world one application at a time. He is currently a maintainer of the Argo Project and OpenGitops. Currently, he works as a Technical Marketing Engineer and Tech Lead at Cisco. He focuses on GitOps practices, DevOps, Kubernetes, Network Security, and Containers.`,
  },
  AkilaInduranga: {
    header: `Akila Induranga`,
    bio: `Akila is a Senior Software Engineer at WSO2, and a maintainer of <a href="https://openchoreo.dev/" target="_blank" rel="noopener noreferrer">OpenChoreo</a>, an open-source internal developer platform for Kubernetes and a CNCF sandbox project.
    He works on the platform's observability and networking layers, including the Cilium-based networking module that brings identity-based policy and Hubble observability to OpenChoreo cells.`,
  },
};
